import { CbInputModule } from '@chubb/ui-components/cb-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsbCoreZipcodeComponent } from './csb-core-zipcode.component';
import { CsbZipcodeService } from './csb-zipcode.service';
import {
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// CRUX HTTP Client Providers
@NgModule({
    declarations: [CsbCoreZipcodeComponent],
    exports: [CsbCoreZipcodeComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        CbInputModule,
        NgxMaskDirective,
        NgxMaskPipe,
    ],
    providers: [
        provideNgxMask(),
        // CRUX Zip Code Service
        CsbZipcodeService,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class CsbCoreZipcodeModule {}
